import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.any.isRequired,
  animationIndex: PropTypes.number,
  delay: PropTypes.number,
  direction: PropTypes.string,
  state: PropTypes.string
};

const AnimateItem = props => {
  const { children, animationIndex, delay = 300, index, direction = 'up', state } = props;
  const childItem = React.Children.toArray(children)?.[0];

  useEffect(() => {
    if (React.Children.toArray(children).length > 1) {
      console.error('Error: Animate item may only have 1 child element');
    }
  }, [children]);

  /**
   * Returns the css translation for a given animation direction
   *
   * @function getTransformation
   * @returns {string} The css translate function
   * @param {string} direction the direction the item should animate
   * @param {string} state the animation state of the item
   */
  const getTransformation = (direction, state) => {
    let axis = 'Y';
    let distance = 20;

    if (direction === 'left' || direction === 'right') {
      axis = 'X';
    }

    if (state === 'entered' || direction === 'none') {
      distance = 0;
    } else if (direction === 'down' || direction === 'right') {
      distance = -distance;
    }

    return `translate${axis}(${distance}px)`;
  };

  /**
   * Returns the animation styles to be applied to the child components
   *
   * @function getAnimationStyle
   * @param {string} state
   * @param {number} delay
   */
  const getAnimationStyle = (delay, state) => {
    return {
      transition: 'opacity 0.8s ease, transform 1.2s ease',
      transitionDelay: `${delay}ms`,
      transform: getTransformation(direction, state),
      opacity: state === 'entered' ? '1' : '0'
    };
  };

  const delayFactor = animationIndex || index;
  const delayAmount = delayFactor * delay;

  return React.cloneElement(childItem, { style: getAnimationStyle(delayAmount, state) });
};

AnimateItem.propTypes = propTypes;

export { AnimateItem };
